// Livros da home (books/_home_books): abas "mais recomendados" / "mais vendidos" e o carrossel
// de cada uma.
//
// Cada lista é uma rolagem lateral nativa com encaixe (CSS): arrastar, trackpad e teclado já
// funcionam. As setas das laterais passam uma página de capas da aba aberta e somem quando não
// há mais nada daquele lado. As abas seguem o padrão de tablist (setas do teclado, Home/End).
// A seção chega por AJAX (books/home_grid.js.erb), que chama window.cdaHomeBooks.init() depois
// de inserir o HTML.

function setup(section) {
  if (section.getAttribute('data-cda-books-bound') === '1') return;

  var prev = section.querySelector('[data-cda-books-prev]');
  var next = section.querySelector('[data-cda-books-next]');
  var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-cda-books-tab]'));
  if (!prev || !next) return;
  section.setAttribute('data-cda-books-bound', '1');

  // lista da aba aberta
  function currentTrack() {
    var panels = section.querySelectorAll('.cda-books__panel');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].hidden) return panels[i].querySelector('[data-cda-books-track]');
    }
    return null;
  }

  // tracinhos (celular): uma "tela" de livros por traço, o atual mais longo
  var dots = section.querySelector('[data-cda-books-dots]');

  function renderDots(track) {
    if (!dots) return;
    var pages = Math.max(1, Math.ceil((track.scrollWidth - 2) / track.clientWidth));
    dots.hidden = pages <= 1;
    if (dots.children.length !== pages) {
      dots.innerHTML = '';
      for (var i = 0; i < pages; i++) dots.appendChild(document.createElement('span'));
    }
    var max = track.scrollWidth - track.clientWidth;
    var current = max > 0 ? Math.round((track.scrollLeft / max) * (pages - 1)) : 0;
    Array.prototype.forEach.call(dots.children, function(dot, index) {
      dot.classList.toggle('is-active', index === current);
    });
  }

  function update() {
    var track = currentTrack();
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
    renderDots(track);
  }

  prev.addEventListener('click', function() {
    var track = currentTrack();
    if (track) track.scrollBy({ left: -pageWidth(track) });
  });

  next.addEventListener('click', function() {
    var track = currentTrack();
    if (track) track.scrollBy({ left: pageWidth(track) });
  });

  var frame = null;
  Array.prototype.forEach.call(section.querySelectorAll('[data-cda-books-track]'), function(track) {
    track.addEventListener('scroll', function() {
      if (frame) return;
      frame = requestAnimationFrame(function() {
        frame = null;
        update();
      });
    }, { passive: true });
  });

  function select(tab, focus) {
    tabs.forEach(function(other) {
      var active = other === tab;
      other.setAttribute('aria-selected', active ? 'true' : 'false');
      other.tabIndex = active ? 0 : -1;
      var panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    // a aba nova começa do início
    var track = currentTrack();
    if (track) track.scrollLeft = 0;
    if (focus) tab.focus();
    update();
  }

  tabs.forEach(function(tab, index) {
    tab.addEventListener('click', function() {
      select(tab, false);
    });

    tab.addEventListener('keydown', function(event) {
      var target = null;
      if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') target = tabs[0];
      else if (event.key === 'End') target = tabs[tabs.length - 1];
      if (!target) return;
      event.preventDefault();
      select(target, true);
    });
  });

  window.addEventListener('resize', update);
  update();
}

// Faixas com setas discretas no cabeçalho (data-cda-strip): autores em destaque
// (books/_home_authors) e o Top 10 do mês (books/_home_top10). As setas passam uma página e
// somem juntas quando tudo já cabe na tela.
function setupStrip(section) {
  if (section.getAttribute('data-cda-strip-bound') === '1') return;

  var track = section.querySelector('[data-cda-strip-track]');
  var arrows = section.querySelector('[data-cda-strip-arrows]');
  var prev = section.querySelector('[data-cda-strip-prev]');
  var next = section.querySelector('[data-cda-strip-next]');
  if (!track || !arrows || !prev || !next) return;
  section.setAttribute('data-cda-strip-bound', '1');

  function update() {
    var max = track.scrollWidth - track.clientWidth;
    arrows.hidden = max <= 2;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  }

  prev.addEventListener('click', function() {
    track.scrollBy({ left: -pageWidth(track) });
  });

  next.addEventListener('click', function() {
    track.scrollBy({ left: pageWidth(track) });
  });

  var frame = null;
  track.addEventListener('scroll', function() {
    if (frame) return;
    frame = requestAnimationFrame(function() {
      frame = null;
      update();
    });
  }, { passive: true });

  window.addEventListener('resize', update);
  update();
}

// uma página = quantos itens inteiros cabem na área visível
function pageWidth(track) {
  var item = track.children[0];
  if (!item) return track.clientWidth;
  var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  var step = item.getBoundingClientRect().width + gap;
  return Math.max(1, Math.floor((track.clientWidth + gap) / step)) * step;
}

function init(root) {
  var scope = root || document;
  Array.prototype.forEach.call(scope.querySelectorAll('[data-cda-books]'), setup);
  Array.prototype.forEach.call(scope.querySelectorAll('[data-cda-strip]'), setupStrip);
}

window.cdaHomeBooks = { init: init };

document.addEventListener('turbolinks:load', function() {
  init(document);
});
